var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgQqOptions(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "qq_options_svg__circle-icon",
    d: "M12.514 7.073h6.026c.185 0 .335-.15.335-.335V.71a.335.335 0 00-.335-.335h-6.026a.335.335 0 00-.335.335v2.177h-3.18a.167.167 0 00-.167.167v5.191H6.823V5.983a.335.335 0 00-.335-.335H.46a.335.335 0 00-.335.335v6.029c0 .185.15.335.335.335h6.026c.185 0 .335-.15.335-.335V9.75H8.83v5.191c0 .092.075.167.166.167h3.18v2.177c0 .185.15.335.336.335h6.026c.185 0 .335-.15.335-.335V11.26a.335.335 0 00-.335-.335h-6.024a.335.335 0 00-.335.335v2.344h-1.842v-9.21h1.842v2.343c0 .185.15.335.335.335zm1.254-5.107h3.516v3.518h-3.516V1.966zm-8.536 8.792H1.716V7.242h3.516v3.516zm8.536 1.76h3.516v3.518h-3.516v-3.518z",
    fill: "#C4C4C4"
  })));
}

export default __webpack_public_path__ + "./fonts/qq_options.ca7d86680929276bd4d9a22878de176c.svg";
export { SvgQqOptions as ReactComponent };